import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../scss/timeline.scss";
import { historyData } from "../utils/historyData";
import { Business } from "@material-ui/icons";

const Timeline = ({ id }) => {
  return (
    <div id={id}>
      <VerticalTimeline>
        {historyData.map((el, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--work"
            date={el.date}
            icon={<Business />}
          >
            <h3 className="vertical-timeline-element-title">{el.title}</h3>
            <p>{el.content}</p>
          </VerticalTimelineElement>
        ))}

        <VerticalTimelineElement
          contentStyle={{ background: "inherit" }}
          iconClassName="icon-none"
        />
      </VerticalTimeline>
    </div>
  );
};

export default Timeline;
